import { render, staticRenderFns } from "./TreatmentVarietyList.vue?vue&type=template&id=6a58077b&scoped=true&"
import script from "./TreatmentVarietyList.vue?vue&type=script&lang=js&"
export * from "./TreatmentVarietyList.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentVarietyList.vue?vue&type=style&index=0&id=6a58077b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58077b",
  null
  
)

export default component.exports